// #1693: verifies a stored Pending Action with the server after login.
// firestore.rules has no document to authorize here — this callable IS the
// check (employer membership, TTL, nonce replay) — see
// functions/deepLinks/resolvePendingAction.js.

import { httpsCallable } from './app'

/**
 * @param {object} params
 * @param {string} params.path
 * @param {string} [params.search]
 * @param {number} params.createdAt Epoch ms, from the locally-stored action.
 * @param {string} params.nonce
 * @return {Promise<{valid: boolean, path: string, search: string}>}
 */
export async function resolvePendingAction({path, search, createdAt, nonce}) {
  const result = await httpsCallable('resolvePendingAction')({path, search, createdAt, nonce})
  return result?.data ?? {}
}
